import { render } from "./Loader.vue?vue&type=template&id=74dd5f13&scoped=true&ts=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=74dd5f13&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dd5f13"]])

export default __exports__